import type { MilestoneTemplate } from "../types";

/** Global milestone definitions — every beneficiary file receives the same checklist structure. */
export const initialMilestoneTemplates: MilestoneTemplate[] = [
  {
    id: "mt-1",
    title: "Phase 1 — Substructure & materials",
    notes: "Standard checks before slab: materials on site and statutory receipts.",
    sortOrder: 1,
    createdAt: "2026-03-01T09:00:00",
    linkedConstructionTimelinePhaseIds: ["1", "2"],
    linkedResourceIds: ["sr-cement", "sr-steel", "sr-bricks", "sr-sand", "sr-aggregate"],
    items: [
      { id: "mti-1-1", kind: "material", label: "Cement & steel — supplier challan verified on site" },
      { id: "mti-1-2", kind: "govt_bill", label: "Treasury / departmental receipt as per scheme circular" },
    ],
  },
  {
    id: "mt-2",
    title: "Phase 2 — Work execution & bills",
    notes: "Work-done bill on dossier; subcontractor invoice for the phase.",
    sortOrder: 2,
    createdAt: "2026-03-01T09:00:00",
    linkedConstructionTimelinePhaseIds: ["5"],
    linkedResourceIds: ["sr-flooring", "sr-windows", "sr-doors"],
    items: [
      {
        id: "mti-2-1",
        kind: "work_done_bill",
        label: "Work-done bill on Bills tab — site seeding re-verification completed",
      },
      { id: "mti-2-2", kind: "subcontractor_bill", label: "Subcontractor / vendor invoice for this construction phase" },
    ],
  },
  {
    id: "mt-3",
    title: "Phase 3 — Completion & handover",
    notes: "Close work order and obtain GP / local body certificate.",
    sortOrder: 3,
    createdAt: "2026-03-01T09:00:00",
    linkedConstructionTimelinePhaseIds: ["10"],
    linkedResourceIds: ["sr-painting", "sr-sanitary", "sr-kitchen", "sr-electrical"],
    items: [
      { id: "mti-3-1", kind: "subcontractor_bill", label: "Subcontractor work order on file matches executed work" },
      { id: "mti-3-2", kind: "govt_bill", label: "GP / local body final inspection certificate" },
    ],
  },
];
